import { render, staticRenderFns } from "./TianjiaHuowu.vue?vue&type=template&id=07ea628e&scoped=true&"
import script from "./TianjiaHuowu.vue?vue&type=script&lang=js&"
export * from "./TianjiaHuowu.vue?vue&type=script&lang=js&"
import style0 from "./TianjiaHuowu.vue?vue&type=style&index=0&id=07ea628e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ea628e",
  null
  
)

export default component.exports